<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "BreakInfinityModal",
  components: {
    ModalWrapperChoice
  },
  computed: {
    message() {
      const infinity = formatPostBreak(Number.MAX_VALUE, 2);
      return `Преодоление Бесконечности позволит вам иметь более чем ${infinity} Антиматерии${PlayerProgress.eternityUnlocked() ? "." : `, и откроет вам доступ к числам после ${infinity}.`}
        Измерения и Улучшения Скорости Тика будут увеличиваться в цене быстрее после ${infinity} антиматерии.
        Вы будете зарабатывать дополнительные Очки Бесконечности при Большом Хрусте, основываясь на количестве антиматерии, произведённой после ${infinity}.\
        ${EternityMilestone.keepAutobuyers.isReached ? "" : `\nЭто также откроет Улучшения Преодоления Бесконечности и
        максимизирует\
        все АвтоПокупщики Обычных Челленджей.`}`.split("\n");
    },
  },
  methods: {
    handleYesClick() {
      breakInfinity();
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    :show-cancel="false"
    @confirm="handleYesClick"
  >
    <template #header>
      Вы Преодолеваете Бесконечность
    </template>
    <div class="c-modal-message__text">
      <span
        v-for="(line, index) in message"
        :key="index"
      >
        {{ line }} <br>
      </span>
    </div>
    <template #confirm-text>
      Преодолеть
    </template>
  </ModalWrapperChoice>
</template>
